import { Outlet } from 'react-router'
import { TennisBall } from '~/components/ui/tennis-ball'

export function AdminLayout() {
  return (
    <div className="min-h-screen relative bg-gradient-to-br from-blue-950/30 via-background to-blue-950/25">
      {/* Tennis ball background element */}
      <div className="fixed top-0 right-0 w-[150vmax] h-[150vmax] pointer-events-none -translate-y-1/2 translate-x-1/2 rotate-12">
        <div className="absolute inset-0 blur-sm opacity-[0.015]">
          <TennisBall
            className="h-full w-full"
            startColor="rgb(59, 130, 246)"
            midColor="rgb(96, 165, 250)"
            endColor="rgb(37, 99, 235)"
            gradientId="admin-layout-tennis-ball-gradient"
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative px-1">
        <Outlet />
      </div>
    </div>
  )
}
